export const KLYDO_YELLOW = '#FFD848';
export const KLYDO_BLACK = '#0C0C0C';
export const KLYDO_WHITE = '#fdfdfd';
export const PENDING = '#FFA726';
export const REJECTED = '#F44336';
export const DRAFT = 'rgba(255, 255, 255, 0.7)';
export const APPROVED = '#66BB6A';
